import { generateHttpClient } from '@wisestamp/common';
import { biAnalyticsApiMethods } from './generated/proto/bi-analytics-api';
import { userGatewayMethods } from './generated/proto/common-api';
import { organizationApiMethods } from './generated/proto/organization-api';
import { userProfileGatewayMethods } from './generated/proto/user-profile-api';
import { upgradeGatewayMethods } from './generated/proto/upgrade-api';
import { BASE_ROUTE, BI_ANALYTICS_API_BASE_ROUTE, ORGANIZATION_API_BASE_ROUTE, USER_PROFILE_BASE_ROUTE, } from './consts';
/**
 * Auto generated client with all the API methods\
 * Pro tip: Don't forget to call the init method\
 * if any of the gateway methods requires auth^2 a IAuth
 * instance must be passed to the init method\
 * (Even if you are not using guarded methods)
 */
export const userGateway = generateHttpClient({
    baseRoute: BASE_ROUTE,
    methods: userGatewayMethods,
    sdkPackageName: '@msl/user-gateway-sdk',
    requireAuth: true,
});
export const organizationApi = generateHttpClient({
    baseRoute: ORGANIZATION_API_BASE_ROUTE,
    methods: organizationApiMethods,
    sdkPackageName: '@msl/user-gateway-sdk',
    requireAuth: true,
});
export const userProfileGateway = generateHttpClient({
    baseRoute: USER_PROFILE_BASE_ROUTE,
    methods: userProfileGatewayMethods,
    sdkPackageName: '@msl/user-gateway-sdk',
    requireAuth: true,
});
export const upgradeGateway = generateHttpClient({
    baseRoute: BASE_ROUTE,
    methods: upgradeGatewayMethods,
    sdkPackageName: '@msl/user-gateway-sdk',
    requireAuth: true,
});
export const biAnalyticsApi = generateHttpClient({
    baseRoute: BI_ANALYTICS_API_BASE_ROUTE,
    methods: biAnalyticsApiMethods,
    sdkPackageName: '@msl/user-gateway-sdk',
    requireAuth: ['reportRegisteredUserAnalyticEvent'],
});
//# sourceMappingURL=api.js.map